import { FieldError, FieldErrorsImpl, Merge, useFormContext } from "react-hook-form";

import { Input, Label } from "@fronterahealth/frontera-ui-components";

import { FieldValidation } from "@components/AssessmentFormRenderer/types/layoutTypes";

interface FormInputFieldProps {
  fieldPath: string;
  inputType?: string;
  editable: boolean;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl>;
  validation?: FieldValidation;
  label?: string;
}

export const FormInputField: React.FC<FormInputFieldProps> = ({
  fieldPath,
  inputType = "text",
  editable,
  error,
  validation,
  label = "",
}) => {
  const { register, watch } = useFormContext();
  const value = watch(fieldPath);

  if (!editable) {
    return <Label>{value !== "" && value != null ? value : "—"}</Label>;
  }

  const registerOptions =
    inputType === "number" ? { setValueAs: (v: string) => (v === "" || v === undefined ? null : Number(v)) } : {};

  return (
    <Input
      {...register(fieldPath, registerOptions)}
      type={inputType}
      inputSize="full"
      formNoValidate={!error}
      errorMessage={error?.message ? String(error.message) : undefined}
      label={label}
      step={validation?.step}
      min={validation?.min}
      max={validation?.max}
    />
  );
};
